import { render } from "./AmendBookingDates.vue?vue&type=template&id=605cb208&scoped=true&lang=pug"
import script from "./AmendBookingDates.vue?vue&type=script&lang=ts"
export * from "./AmendBookingDates.vue?vue&type=script&lang=ts"

import "./AmendBookingDates.vue?vue&type=style&index=0&id=605cb208&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-605cb208"

export default script